<template>
  <v-card
    class="kpi-card"
    :class="{
      'kpi-card--selected': isSelected,
      'kpi-card--selectable': isSelectable,
    }"
    :elevation="isSelected ? 4 : 2"
  >
    <v-card-title class="kpi-card__title">
      <v-icon left color="contrast">mdi-target</v-icon>
      {{ kpi.name }}
      <v-spacer></v-spacer>
      <v-chip
        v-if="isSelected && isSelectable"
        small
        color="success"
        class="kpi-card__chip"
      >
        <div style="display: flex; gap: 4px; align-items: center">
          <div>Selected</div>
          <v-icon color="success" small>mdi-check-circle</v-icon>
        </div>
      </v-chip>
    </v-card-title>

    <v-card-item class="kpi-card__content">
      <div v-if="kpi.pillar" class="detail-row">
        <v-icon small color="contrast">mdi-ruler</v-icon>
        <span class="detail-text">
          {{ kpi.pillar }}
          <span class="detail-unit" v-if="kpi.unit"> ({{ kpi.unit }}) </span>
        </span>
      </div>

      <div v-if="kpi.impact" class="detail-row">
        <v-icon small color="contrast">mdi-flash</v-icon>
        <span class="detail-text">{{ kpi.impact }}</span>
      </div>

      <div v-if="kpi.description" class="detail-row description-row">
        <v-icon small color="contrast">mdi-text</v-icon>
        <span class="detail-text">{{ kpi.description }}</span>
      </div>

      <div
        v-if="!kpi.unit && !kpi.pillar && !kpi.impact && !kpi.description"
        class="detail-row no-details"
      >
        <v-icon small color="contrast">mdi-information-outline</v-icon>
        <span class="detail-text">No details available</span>
      </div>
    </v-card-item>

    <v-spacer></v-spacer>

    <!-- Card actions -->
    <v-card-actions class="kpi-card__actions">
      <v-spacer></v-spacer>
      <v-btn v-if="!isSelectable" color="primary" @click="handleEdit">
        <v-icon>mdi-pencil</v-icon>
        Edit
      </v-btn>
      <v-btn v-if="!isSelectable" color="error" @click="handleDelete">
        <v-icon>mdi-delete</v-icon>
        Remove
      </v-btn>
      <v-btn
        v-if="isSelectable"
        :color="isSelected ? 'error' : 'primary'"
        @click="handleClick"
      >
        <v-icon left>
          {{ isSelected ? "mdi-close-circle" : "mdi-check-circle" }}
        </v-icon>
        {{ isSelected ? "Unselect" : "Select" }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "KpiCard",

  props: {
    kpi: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isSelectable: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["toggle", "delete", "edit"],

  methods: {
    handleClick() {
      this.$emit("toggle", this.kpi);
    },

    handleDelete() {
      this.$emit("delete", this.kpi.id);
    },

    handleEdit() {
      this.$emit("edit", this.kpi);
    },
  },
};
</script>

<style scoped>
.kpi-card {
  margin: 8px;
  transition: all 0.2s ease;
  position: relative;
  background-color: rgba(255, 255, 255, 0.05) !important;
}

.kpi-card__title {
  font-weight: bold;
  font-size: 1.2em;
  color: var(--contrastColor) !important;
  padding-bottom: 4px;
  white-space: wrap;
}

.kpi-card__content {
  padding-top: 0;
}

.kpi-card__chip {
  margin-left: 8px;
}

.detail-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 6px;
}

.detail-row .v-icon {
  margin-top: 2px;
  flex-shrink: 0;
}

.detail-text {
  font-size: 0.875rem;
  line-height: 1.4;
  color: var(--contrastColor) !important;
  word-break: break-word;
}

.detail-unit {
  font-style: italic;
}

.description-row {
  font-style: italic;
  white-space: pre-wrap;
}

.no-details {
  font-style: italic;
  display: flex;
  align-items: center;
  padding-left: 5px;
}

.kpi-card--selected {
  border: 2px solid var(--contrastColor);
}

.kpi-card--selectable:hover {
  cursor: pointer;
  opacity: 0.8;
}
</style>
